<template>
  <section id="kelebihan-kami" class="gr-section gr-advantages">
    <div class="gr-container">
      <header class="gr-head">
        <p class="gr-eyebrow" aria-hidden="true">
          <span class="gr-eyebrow__index">02</span>
          <span class="gr-eyebrow__rule" />
        </p>
        <h2 class="gr-h2">Kelebihan Kami</h2>
      </header>

      <ul class="gr-advantages__list">
        <li
          v-for="advantage in advantages"
          :key="advantage.title"
          class="gr-advantages__item"
        >
          <div class="gr-advantages__mark">
            <img
              :src="advantage.image"
              :alt="advantage.title"
              class="gr-advantages__icon"
              width="96"
              height="96"
              loading="lazy"
              decoding="async"
            />
          </div>
          <h3 class="gr-advantages__title">{{ advantage.title }}</h3>
          <p class="gr-advantages__copy">{{ advantage.description }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts" setup>
// Copy and assets carried over verbatim. The canonical `srcset` is dropped:
// it advertises `<name>-sm.webp` files that do not exist under
// `web/public/assets/images/`, so the 120w candidate resolves to a 404.
const advantages = [
  {
    title: "Inclusive Platform",
    description:
      "Sebuah konsep dimana setiap individu tanpa memandang latar belakang memiliki akses dan kesempatan yang sama untuk berpartisipasi dalam suatu ekosistem yang memiliki tujuan memperkuat kekuatan masyarakat melalui partisipasi aktif dan berkontribusi untuk perubahan positif.",
    image: "/assets/images/inclusive-platform.webp",
  },
  {
    title: "No Money Oriented",
    description:
      "Fokus pada tujuan untuk mendorong kebersamaan, solidaritas, dan kebermanfaatan untuk sesama tanpa didasarkan pada keuntungan pribadi maupun kelompok.",
    image: "/assets/images/no-money-oriented.webp",
  },
  {
    title: "Social to Professional",
    description:
      "Semangat kebersamaan dan kerja sama sosial menjadi pondasi yang kuat untuk membangun keterampilan profesional dari setiap individu demi mencapai tujuan bersama yang lebih terstruktur dan terorganisir.",
    image: "/assets/images/social-to-professional.webp",
  },
];
</script>

<style scoped>
.gr-advantages__list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.gr-advantages__item {
  min-width: 0;
  padding-block: 2rem;
  border-top: 1px solid var(--gr-line);
}

.gr-advantages__item:first-child {
  border-top: none;
  padding-top: 0;
}

@media (min-width: 960px) {
  .gr-advantages__list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .gr-advantages__item {
    padding: 0 2rem;
    border-top: none;
    border-left: 1px solid var(--gr-line);
  }

  .gr-advantages__item:first-child {
    padding-left: 0;
    border-left: none;
  }

  .gr-advantages__item:last-child {
    padding-right: 0;
  }
}

.gr-advantages__mark {
  display: grid;
  place-items: center;
  width: 96px;
  height: 96px;
  margin-bottom: 1.25rem;
  border-radius: 4px;
  background-color: var(--gr-green-tint);
}

.gr-advantages__icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

/* green-darken-4 (#1b5e20): spec 003 criterion 10 requires at least 7.00:1 for
   this heading. It measures 7.9:1 on the candidate paper ground. */
.gr-advantages__title {
  margin: 0 0 0.625rem;
  color: var(--gr-green-deep);
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.005em;
  line-height: 1.25;
}

.gr-advantages__copy {
  max-width: 46ch;
  margin: 0;
  color: var(--gr-ink-2);
  font-size: 1rem;
  line-height: 1.7;
}
</style>
